import TopHeader from "components/common/header";
import BriefingHeader from "components/templates/common/Briefing/Header";
import { useBriefingData } from "utils/clientAPIs/discuss";
import moment from "moment-timezone";
import BriefingPagenation from "components/templates/common/Briefing/Pagenation";
import { useEffect, useState } from "react";
import BriefingSlide from "components/templates/common/Briefing/Slide";
import BriefingPagenationButton from "components/templates/common/Briefing/PagenationButton";
import BriefingAlarmButton from "components/templates/common/Briefing/AlarmButton";
import SkeletonBlock from "components/skeleton";
import { useRouter } from "next/router";
import BriefingProgress from "components/templates/common/Briefing/Progress";

function BriefingPage({ isMobile }: { isMobile: boolean }) {
  const [briefingData, isBriefingDataLoading] = useBriefingData();
  const date = briefingData?.[0]?.base_dt;
  const router = useRouter();
  const { step } = router.query;
  const [currentPage, setCurrentPage] = useState(step ? Number(step) : 0);
  const isFinishPage = currentPage === briefingData?.length;
  const totalPages = briefingData?.length;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isBriefingDataLoading)
    return (
      <main className="min-w-[360px] max-w-[800px] w-screen bg-white min-h-screen relative">
        <BriefingHeader isMobile={isMobile} />
        <div className="p-6">
          <SkeletonBlock width={"100%"} height={500} />
        </div>
      </main>
    );
  return (
    <main
      className={`min-w-[360px] max-w-[800px] w-screen min-h-screen relative ${
        isMobile ? "bg-gray2" : "bg-white"
      }`}
    >
      <BriefingHeader
        title={`${moment(date).format("M월 D일")} 브리핑`}
        isMobile={isMobile}
      />
      <BriefingProgress currentPage={currentPage} totalPages={totalPages} />
      <BriefingSlide
        data={briefingData}
        date={date}
        currentPage={currentPage}
        isMobile={isMobile}
        isFinishPage={isFinishPage}
      />
      {!isFinishPage && (
        <BriefingPagenationButton
          isMobile={isMobile}
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
        />
      )}
      {isFinishPage && <BriefingAlarmButton isMobile={isMobile} />}
    </main>
  );
}
export default BriefingPage;
